module.exports = __webpack_public_path__ + "static/media/64pic.7b0852a3.jpg";